import React, { PureComponent } from 'react'
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from 'recharts'
import styled from 'styled-components'

// const data = [
//   {
//     back: 3200,
//     pay: 5200,
//   },
// ]

type RangeChartParam = {
  minRange: number // ProgressBar의 전체영역
  maxRange: number
  minValue: number // ProgressBar의 데이터 영역
  maxValue: number
  color: string
  height?: number
}

function RangeChart(props: RangeChartParam) {
  const data = [
    {
      back: props.minValue,
      pay: props.maxValue - props.minValue,
      back2: props.maxRange - props.maxValue,
    },
  ]
  return (
    <Wrapper>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={props.height ?? 60}
          data={data}
          layout="vertical"
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
          barGap={0}
          barCategoryGap={0}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis
            type="number"
            tickCount={14}
            domain={[
              Math.min(0, props.minRange),
              Math.max(10000, props.maxRange),
            ]}
          />
          <YAxis type="category" hide />
          <Bar
            dataKey="back"
            stackId="a"
            fill="white"
            isAnimationActive={false}
            label={`${props.minValue}만원`}
          ></Bar>
          <Bar
            dataKey="pay"
            stackId="a"
            fill={props.color}
            isAnimationActive={false}
            label="aff"
          ></Bar>
          <Bar
            dataKey="back2"
            stackId="a"
            fill="white"
            isAnimationActive={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 60px;
  margin-bottom: 15px;
`
export default RangeChart
